import { CostCodeGroupsQuery, CostCodeGroupsQueryVariables } from '__generated__/graphql';
import { costCodeGroupsQuery } from 'components/domain/cost-code-group/CostCodeGroupPicker/cost-code-group-picker-queries';
import useGraphQLClient from 'hooks/graphql/useGraphQLClient/useGraphQLClient';
import { useCallback } from 'react';
import { NonNullArrayField } from 'types/util/NonNullArrayField';

export type CostCodeGroupPickerItem = NonNullArrayField<CostCodeGroupsQuery['costCodeGroups']>;

export function useCostCodeGroupPickerData() {
  const graphqlClient = useGraphQLClient();

  const fetchPage = useCallback(
    async (after: string | null, first: number): Promise<CostCodeGroupPickerItem[]> => {
      const result = await graphqlClient.request<CostCodeGroupsQuery, CostCodeGroupsQueryVariables>({
        document: costCodeGroupsQuery,
        variables: {
          after,
          first,
          filter: { deletedOn: { isNull: true } },
        },
      });

      return result.costCodeGroups ?? [];
    },
    [graphqlClient]
  );

  const fetchSelected = useCallback(
    async (ids: string[]): Promise<CostCodeGroupPickerItem[]> => {
      const result = await graphqlClient.request<CostCodeGroupsQuery, CostCodeGroupsQueryVariables>({
        document: costCodeGroupsQuery,
        variables: { filter: { id: { contains: ids } } },
      });

      return result.costCodeGroups ?? [];
    },
    [graphqlClient]
  );

  return { fetchPage, fetchSelected };
}
